import { useMemo } from 'react';
import { Option } from 'shared/components/ui/form-select';
import {
  TimeFormatOptions,
  timeFormatOptionToLabelMap,
} from 'shared/types/date-format-options';

export const useTimeFormatOptions = () =>
  useMemo<Option[]>(
    () =>
      Object.values(TimeFormatOptions).map((format) => ({
        value: format,
        label: timeFormatOptionToLabelMap[format],
      })),
    [],
  );
